import { Invoice, IssueTaskDoc } from '@gooduncles/gu-app-schema';

import { issueTaskCategoryKr } from 'src/constants/issue.constants';
import { getServerTime } from 'src/utils/date-util';
import { FirebaseManager } from 'src/utils/firebase/firebase-manager';
import {
  createInvoice,
  updateIssueTaskNestedFields,
  updateOrder,
  updateSettlementResult,
  updateStoreIssue,
} from 'src/utils/firebase/firebase-short-cut';

import { InProgressTaskItem } from '../components/InProgressTasksModal';

const firebaseManager = FirebaseManager.getInstance();

/**
 * Invoice를 생성하고 관련 문서들의 invoiceId를 업데이트합니다.
 * @description invoice 생성시 관련된 주문과 매장이슈의 invoiceId를 업데이트합니다.
 */
export const createInvoicesWithUpdateChildren = async (invoices: Invoice[]): Promise<void> => {
  const serverTime = await getServerTime();
  firebaseManager.batchStart();

  for (const invoice of invoices) {
    const { orderIds, storeIssueIds, issueTaskIds, prevSettlementResultId } = invoice;

    const docId = await createInvoice(
      {
        ...invoice,
        date: serverTime,
      },
      { bBatch: true },
    );

    for (const orderId of orderIds) {
      await updateOrder(orderId, { invoiceId: docId }, { bBatch: true });
    }

    for (const storeIssueId of storeIssueIds) {
      await updateStoreIssue(storeIssueId, { invoiceId: docId }, { bBatch: true });
    }

    for (const issueTaskId of issueTaskIds) {
      await updateIssueTaskNestedFields(issueTaskId, { invoiceInfo: { invoiceId: docId } }, { bBatch: true });
    }

    if (prevSettlementResultId) {
      await updateSettlementResult(prevSettlementResultId, { invoiceIdForUnpaid: docId }, { bBatch: true });
    }
  }

  await firebaseManager.batchEnd();
};

/**
 * IssueTaskDoc 배열을 InProgressTaskItem 배열로 변환합니다.
 */
export const convertToInProgressTaskItems = (tasks: IssueTaskDoc[]): InProgressTaskItem[] => {
  return tasks.map((task) => ({
    key: task._id,
    storeId: task.storeId,
    storeName: task.storeName,
    category: issueTaskCategoryKr[task.category],
    targetDate: task.targetDate,
    privateNote: task.privateNote,
  }));
};

/**
 * 특정 날짜와 매장 ID에 해당하는 IN_PROGRESS 태스크를 필터링합니다.
 */
export const filterConflictingTasks = (
  tasks: IssueTaskDoc[],
  storeIds: Set<string>,
  targetDate: string,
): IssueTaskDoc[] => {
  return tasks.filter((task) => storeIds.has(task.storeId) && task.targetDate === targetDate);
};
